import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import Chip from "@mui/material/Chip";
import dayjs from "dayjs";
import TableStatusRow from "../../../components/TableStatusRow/TableStatusRow";
import CustomTooltip from "../../../components/CustomTooltip/CustomTooltip";
import { APP_PLATFORM, getPlatformLabel } from "../../../utils/appPlatform";

const APP_VERSIONS_TABLE_COLUMN_COUNT = 5;

const PLATFORM_CHIP_COLOR = {
  [APP_PLATFORM.ANDROID]: { backgroundColor: "#e6f4ea", color: "#1e7e34" },
  [APP_PLATFORM.IOS]: { backgroundColor: "#e8f0fe", color: "#104581" },
};

const AppVersionsTable = ({
  rows,
  isLoading,
  fetchError,
  onRetry,
  page,
  rowsPerPage,
  totalRows,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <div className="mainadd_container">
    <div className="mainadd_container_table">
      <TableContainer component={Paper}>
        <Table aria-label="app versions table">
          <TableHead>
            <TableRow>
              <TableCell>SL NO</TableCell>
              <TableCell>Platform</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Release Notes</TableCell>
              <TableCell>Created Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.length === 0 ? (
              <TableStatusRow
                colSpan={APP_VERSIONS_TABLE_COLUMN_COUNT}
                loading={isLoading}
                error={fetchError}
                onRetry={onRetry}
                emptyMessage="No app versions found"
              />
            ) : (
              rows.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>
                    <Chip
                      label={row.platformName || getPlatformLabel(row.platform)}
                      size="small"
                      sx={PLATFORM_CHIP_COLOR[row.platform] || {}}
                    />
                  </TableCell>
                  <TableCell style={{ fontWeight: 600, color: "#104581" }}>
                    {row.version || "-"}
                  </TableCell>
                  <TableCell>
                    <CustomTooltip title={row.releaseNotes || ""}>
                      <span className="app-versions-notes">{row.releaseNotes || "-"}</span>
                    </CustomTooltip>
                  </TableCell>
                  <TableCell>
                    {row.createdDate ? dayjs(row.createdDate).format("DD MMM YYYY, hh:mm A") : "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
    <div className="mainadd_container_pagination">
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </div>
  </div>
);

export default AppVersionsTable;
